import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { PriceAlertsResult } from './ingress';
import { Session } from '@benzinga/session';
import { PriceAlertsEnvironment } from './environment';
import { PriceAlerts } from './proto/price_alerts_protos';

export class PriceAlertsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(PriceAlertsEnvironment).url, session, { authorizationSession: true });
  }

  public getAlerts = (): SafePromise<PriceAlertsResult> => {
    const url = this.URL('price-alerts/alerts');
    return this.debouncedGet(url, { credentials: 'same-origin' });
  };

  public addAlert = (data: Partial<PriceAlerts.PostAlertRequest>): SafePromise<PriceAlerts.PostAlertResponse> => {
    const url = this.URL('price-alerts/alerts');
    return this.post(url, data, { credentials: 'same-origin' });
  };

  public updateAlert = (data: Partial<PriceAlerts.PostAlertRequest>): SafePromise<PriceAlerts.PostAlertResponse> => {
    const url = this.URL('price-alerts/alerts');
    return this.put(url, data, { credentials: 'same-origin' });
  };

  public deleteAlert = (guid: string): SafePromise<Response> => {
    const url = this.URL(`price-alerts/alerts/${guid}`);
    return this.delete(url, { credentials: 'same-origin' });
  };
}
